import dayjs from "dayjs";
import 'dayjs/locale/es'; 
import 'dayjs/locale/en'; 
import i18n from "i18next";
import {reactI18nextModule} from "react-i18next";

import translationEN from './locales/en.json';
import translationES from './locales/es.json';

const lang = localStorage.getItem('language') || 'es';
dayjs.locale(lang);


const resources = {
    en: {
        translation: translationEN
    },
    es: {
        translation: translationES
    }
};

i18n
    .use(reactI18nextModule) // passes i18n down to react-i18next
    .init({
        resources,
        lng: lang,

        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
